// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_gy-6";
export var emphasizeQuantity = "_gy-3";
export var flatBottomCorners = "_gy-5";
export var productImage = "_gy-0";
export var quantityContainer = "_gy-2";
export var tooltip = "_gy-1";
export var wrapAndEllipsesOverflow = "_gy-4";